export default __webpack_public_path__ + "static/media/laundry2-afterB-2048w.6f90ab24.webp";